import { render, staticRenderFns } from "./prevBtn.vue?vue&type=template&id=2caf8dc1&"
import script from "./prevBtn.vue?vue&type=script&lang=js&"
export * from "./prevBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports